let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1FqRQ")).then(() => parcelRequire('iekCJ'));